import { isFreelancerPlanTier, type TherapistPlanTier } from './freelancerSubscriptionAccess';

export type PilotFreelancerUserLike = {
  therapistTrialEndsAt?: string | null;
  therapistPlanTier?: string | null;
};

/** Pilot invite bypass: DB trial on User (no Stripe). Set only via redeemTherapistPilotInvite. */
export function isActivePilotFreelancerTrial(
  user: PilotFreelancerUserLike | null | undefined
): boolean {
  if (!user?.therapistTrialEndsAt) return false;
  if (!isFreelancerPlanTier(user.therapistPlanTier)) return false;
  const ends = new Date(user.therapistTrialEndsAt);
  if (Number.isNaN(ends.getTime())) return false;
  return ends > new Date();
}

export function getPilotTrialEndsAtIso(
  user: PilotFreelancerUserLike | null | undefined
): string | null {
  if (!isActivePilotFreelancerTrial(user)) return null;
  return user!.therapistTrialEndsAt!;
}

export function getPilotPlanTier(
  user: PilotFreelancerUserLike | null | undefined
): TherapistPlanTier | undefined {
  if (!isActivePilotFreelancerTrial(user)) return undefined;
  const tier = user?.therapistPlanTier?.toUpperCase();
  if (tier === 'STARTER' || tier === 'GROWTH' || tier === 'PROFESSIONAL') {
    return tier;
  }
  return 'STARTER';
}
